/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const OfferBindingValue = zod
  .object({
    type: zod.enum(["BINDING"]),
    key: zod.enum(["$me.email", "$technical_director"]),
  })
  .describe("Exact backend-owned keys, not expressions or user IDs.");

export type OfferBindingValue = zod.input<typeof OfferBindingValue>;
export type OfferBindingValueOutput = zod.output<typeof OfferBindingValue>;
